import { Component } from '@angular/core';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../_core/_services/auth.service';
import { NotificationService } from '../../_core/_services/notification.service';
import { defaultRouteForRole } from '../../_core/_helpers/role-navigation.helper';

type ChangePasswordForm = FormGroup<{
  currentPassword: FormControl<string>;
  newPassword: FormControl<string>;
  confirmPassword: FormControl<string>;
}>;

@Component({
  selector: 'app-change-password',
  standalone: false,
  templateUrl: './change-password.html',
  styleUrl: './change-password.css',
})
export class ChangePassword {
  loading = false;
  submitted = false;
  error = '';
  success = '';

  form!: ChangePasswordForm;

  constructor(
    private notifyService: NotificationService,
    private fb: FormBuilder,
    private auth: AuthService,
    private router: Router
  ) {
    // if no token, force login
    if (!this.auth.accessToken) {
      this.router.navigateByUrl('/auth/login');
      return;
    }

    this.form = this.fb.nonNullable.group({
      currentPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', [Validators.required]],
    });
  }

  submit() {
    this.submitted = true;
    this.error = '';
    this.success = '';

    if (this.form.invalid) return;

    const { currentPassword, newPassword, confirmPassword } = this.form.getRawValue();

    if (newPassword !== confirmPassword) {
      this.error = 'New password and confirmation do not match.';
      return;
    }

    this.loading = true;

    this.auth.changePassword(currentPassword, newPassword, confirmPassword).subscribe({
      next: () => {
        this.success = 'Password changed successfully.';
        this.notifyService.showSuccess(this.success!, 'Success');

        this.auth.clearUser();
        this.auth.getCurrentUser().subscribe(user => {
          setTimeout(() => {
            this.router.navigateByUrl(defaultRouteForRole(user?.role));
          }, 500);
        });
      },
      error: (err) => {
        const apiBody = err?.error;
        this.error =
          apiBody?.message ??
          apiBody?.Message ??
          apiBody?.error?.code ??
          apiBody?.Error?.Code ??
          err?.message ??
          'Change password failed.';
        this.loading = false;

        this.notifyService.showError(this.error!, 'Error');
      },
      complete: () => (this.loading = false),
    });
  }
}
